var React = require('react');

function MinimizedTxt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.41961 1.42279H11.4372V14.8002H9.0387V16.2229H15.2584V14.8002H12.8599V1.42279H18.8775V4.34875H20.3003V0H3.99683V4.34875H5.41961V1.42279Z","fill":"#836CF2","key":0}),React.createElement("path",{"d":"M21.161 17.7283L20.1549 18.7343L21.5734 20.1528H2.72343L4.14189 18.7343L3.13585 17.7283L0 20.8642L3.13585 24L4.14189 22.9939L2.72347 21.5755H21.5733L20.1549 22.9939L21.161 24L24.2968 20.8642L21.161 17.7283Z","fill":"#836CF2","key":1})]);
}

MinimizedTxt.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = MinimizedTxt;

MinimizedTxt.default = MinimizedTxt;
